import { render, staticRenderFns } from "./TopBar2.vue?vue&type=template&id=4d1b4d73&"
import script from "./TopBar2.vue?vue&type=script&lang=ts&"
export * from "./TopBar2.vue?vue&type=script&lang=ts&"
import style0 from "./TopBar2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports